
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tiktok-reports/[id]",
      function () {
        return require("private-next-pages/tiktok-reports/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tiktok-reports/[id]"])
      });
    }
  